"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.InfoCell = exports.EDITABLE_FIELD = exports.UNEDITABLE_FIELD = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_2 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var field_editorv2_1 = require("../field-editor/field-editorv2");
var field_editor_1 = require("../field-editor/field-editor");
var ui_common_1 = require("@codametrix/ui-common");
var conditionalUtils = ui_common_1.AmplifyCore.conditionalUtils;
var caseEdit = ui_common_1.AmplifyCore.state.capabilities.capabilities.caseEdit;
var BASE_FIELD = {
    showCoderNotesInfo: function (coderNotesParams) { },
    showProviderInfo: function (providerInfo) { },
    updateValue: function (value) { },
    updateCase: function (idAndUpdates) { },
    loadPatientDetailOptions: function (dictionaryInfo) { }
};
exports.UNEDITABLE_FIELD = __assign(__assign({}, BASE_FIELD), { editEnabled: false });
exports.EDITABLE_FIELD = __assign(__assign({}, BASE_FIELD), { editEnabled: true });
var InfoCell = function (props) {
    var _a;
    var defaultClassname = 'col-4 col-md-12';
    var cellKey = props.cellKey, label = props.label, value = props.value, fieldType = props.fieldType, fieldEditorInfo = props.fieldEditorInfo, _b = props.className, className = _b === void 0 ? defaultClassname : _b, capability = props.capability, hasLink = props.hasLink, additionalInfo = props.additionalInfo, showProviderInfo = props.showProviderInfo, spreadable = __rest(props, ["cellKey", "label", "value", "fieldType", "fieldEditorInfo", "className", "capability", "hasLink", "additionalInfo", "showProviderInfo"]);
    var classes = (0, classnames_1["default"])("".concat(cellKey, "-cell"), 'info-cell', 'encounter-info', className);
    var additionalInfoHasNA = (additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.providerName) === 'N/A' ||
        (additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.providerNumber) === 'N/A' ||
        (additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.tenantCode) === 'N/A';
    var showLink = hasLink ? value !== 'N/A' && !additionalInfoHasNA : false;
    var updateValue = fieldEditorInfo.updateValue, updateCase = fieldEditorInfo.updateCase;
    var isValidDate = function (date) {
        var _a;
        if (fieldType === 'date') {
            return (fieldType === 'date' &&
                date &&
                (date === 'N/A' || ((_a = ui_common_1.cmxDateTime.parse(date)) === null || _a === void 0 ? void 0 : _a.successfullyParsed)));
        }
        else {
            return false;
        }
    };
    var handleProviderClick = function (ev) {
        ev.preventDefault();
        if (showLink) {
            showProviderInfo({
                providerName: additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.providerName,
                providerNumber: additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.providerNumber,
                tenantCode: additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.tenantCode
            });
        }
    };
    var _handleChange = function (val) { return __awaiter(void 0, void 0, void 0, function () {
        var caseUpdate;
        return __generator(this, function (_a) {
            if (fieldType === 'dictionary' || isValidDate(val === null || val === void 0 ? void 0 : val.toString())) {
                updateValue({ fieldKey: cellKey, newValue: val });
                caseUpdate = {};
                caseUpdate[cellKey] = val;
                updateCase(caseUpdate);
            }
            return [2 /*return*/];
        });
    }); };
    var showFieldEditor = (fieldType === 'dictionary' || isValidDate(value === null || value === void 0 ? void 0 : value.toString())) &&
        cellKey !== 'date_of_service' &&
        //@ts-ignore
        (capability ? capability.on : (_a = caseEdit.on.value) !== null && _a !== void 0 ? _a : caseEdit.on);
    var hasAmplifyCaseRunV2Access = ui_common_1.Utils.doesPathEndWithV2() ||
        /cmx.*quality-assessment.*case.*case-run/.test(window.location.pathname);
    var flexClasses = (0, classnames_1["default"])('flex-container', className);
    var displayValue = typeof value === 'string' || react_2["default"].isValidElement(value)
        ? value
        : JSON.stringify(value);
    var infoCellContent = (
    //@ts-ignore
    (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, react_1.createElement)("div", __assign({}, spreadable, { className: classes, key: "".concat(cellKey, "-info-cell") }),
            (0, jsx_runtime_1.jsx)("span", __assign({ className: "encounter-field field-label" }, { children: label })),
            showFieldEditor ? (hasAmplifyCaseRunV2Access ? ((0, jsx_runtime_1.jsx)(field_editorv2_1.FieldEditorv2, __assign({ className: "field-data" }, props, { value: value, onChange: _handleChange, onSubmit: function () { }, fieldEditorInfo: fieldEditorInfo }))) : ((0, jsx_runtime_1.jsx)(field_editor_1.FieldEditor, __assign({ className: "field-data" }, props, { value: value, onChange: _handleChange, onSubmit: function () { }, fieldEditorInfo: fieldEditorInfo })))) : ((0, jsx_runtime_1.jsx)("span", __assign({ className: (0, classnames_1["default"])('encounter-detail field-data sensitive-data', "".concat(cellKey, "-field"), { 'cmx-link': showLink }), onClick: function (ev) { return handleProviderClick(ev); } }, { children: displayValue })))) }));
    return infoCellContent;
};
exports.InfoCell = InfoCell;
InfoCell.displayName = 'InfoCell';
InfoCell.defaultProps = {
    fieldEditorInfo: __assign({}, exports.UNEDITABLE_FIELD)
};
//# sourceMappingURL=info-cell.js.map